// The host's agent faces inside the SDK's own chat parts (ECONIC, 23 Oct 2026): the question card shows the face of the agent asking, the
// sidebar's "Thinking…" line ECONIC thinking. The SDK draws no face itself; a host that has faces provides how to draw one, and returns
// null where the person sees today's icons. Without a provider every part renders as before.
import { createContext, useContext, type ReactNode } from "react";
import type { PresenceState } from "../presence";

export interface AgentFaceRequest {
  /** The agent, or null for the conversation's own (the host knows whose conversation it is). */
  agentKey: string | null;
  state: PresenceState;
  size: 16 | 20 | 24;
}
export type RenderAgentFace = (w: AgentFaceRequest) => ReactNode;

export const AgentFaceContext = createContext<RenderAgentFace | null>(null);

/** The host's face for an agent, or null (no provider, or the Icon style). */
export function useAgentFace(w: AgentFaceRequest): ReactNode {
  const render = useContext(AgentFaceContext);
  return render ? render(w) : null;
}
